import React, { useEffect, useState } from 'react'
import styles from './Signup.module.scss';
import logoImg from './assets/lander_logo.png'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Statistic } from 'antd';
import dayjs from 'dayjs';
import { createAccount, getSignupUserDetails } from './SignupHooks';
import { auth0Config } from '../config/auth0Config';
// import SignupStatus from './SignupStatus';


type verifyStatus = 'invitation_not_found' | 'expired' |  'verified' | 'unverified' | 'error' 

const { Countdown } = Statistic;

function EmailVerify() {
    const navigate = useNavigate(); 
    const [loading, setLoading] = useState<boolean>(true)
    const [emailStatus, setEmailStatus] = useState<verifyStatus> ('unverified')
    const deadline:any = dayjs().add(5, 'second');
    const [searchParams] = useSearchParams(); 
    const orgId = searchParams.get('orgId') ?? '' ;
    const ticketId = searchParams.get('ticketID')  ?? '';
    const [userId, setUserId] = useState<string>('')
    const [metaData, setMetaData] = useState<any>({})
    
    const getUserDetailsFun = async () => {
        if (!orgId || !ticketId){
            // console.log(' ---- Yesss')
            setLoading(false)
            setEmailStatus('invitation_not_found');
            return
        }
        let data = {
            orgId,
            ticketId
        }
        try {
            setLoading(true)
            //Get user details
            // await new Promise(resolve => setTimeout(resolve, 2000));
            const resp = await getSignupUserDetails(data) 
            
            if (resp?.data?.response){
                let errMsg = resp?.data?.response?.data?.message.toLowerCase();
                if (errMsg.includes('expired')) {
                    setEmailStatus('expired');
                } else if (errMsg.includes('not found')) {
                    setEmailStatus('invitation_not_found');
                }
            }
            let userMeta = resp?.data?.metadata;
            if(userMeta ){
                setMetaData(userMeta) 
                const payloadPostCall = {
                    given_name: userMeta.firstName,
                    family_name: userMeta.lastName,
                    phone_number: userMeta.phoneNumber 
                }
                console.log("payloadPostCall", payloadPostCall)
                //Post user details - Create Account
                const userCreateResponse = await createAccount(data, payloadPostCall)
                
                if(userCreateResponse?.data){
                    console.log("userCreateResponse.data" , userCreateResponse?.data?.user_id) 
                    setUserId(userCreateResponse?.data?.user_id)
                    setEmailStatus('verified')
                }

            }
        } catch (error) {
            console.error('Error verifying email:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
        getUserDetailsFun()
    },[])

   
  return (
    <>
       {loading && <article className={styles.loaderWrap}>
            
            <div className={styles.loader}></div>
            
        </article>
        } 

        {emailStatus === 'verified' && <section className={`${styles.signup} ${styles.verify}`}>
            <div className={styles.logoTop}><img src={logoImg} /></div>
            <div className={styles.signup_wraper}>
            
            <h2><b>Success! 🎉</b></h2>

            <p>Your email address has been successfully verified.</p>

            <h4>What's next?</h4>
            <ul>
                <li>✅  &nbsp; Dive into your account dashboard.</li>
                <li>✅  &nbsp; Start using the features available to you.</li>
            </ul>
            <h2 className={styles.redirectingText}><i>Redirecting you to the login page...</i></h2>
            <div style={{display: 'none'}}>
                <Countdown title="Redirecting to login in:" value={deadline} onFinish={()=> navigate('/login')} format="s [seconds]" />              
            </div>
            </div>
            </section>} 
    </>
   
  )
}

export default EmailVerify